import React from 'react';
import PropTypes from 'prop-types';
import GenericIcon from './fontIcons/genericIcon';
import './fontIcons/fontIconStyle.css';

const ParkingIcon = ({ ...props }) => {
  const { color, size } = props;
  return (
    <GenericIcon
      color={color}
      size={size}
      fontClass="icon-ic_auto-estacionamiento"
    />
  );
};

ParkingIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

export default ParkingIcon;
